<template>
  <div class="RouteContainer">
    <app-gallery-section :sectionIndex="1"/>
  </div>
</template>

<script>
import appGallerySection from './../gallery/gallery-section'

export default {
  name: 'packAnatomy',

  components: {
    appGallerySection
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/pack-anatomy.vue